import React, { useState, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { getDlsCompatibleList } from "./selector";
import { Label } from "@cars24/turbo-web/lib/label";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { NUMBER } from "../../../constants/app-constants";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import ArrowIcon from "../../shared/arrow";
import styles from "./styles.css";
import List from "../list";

const LIST_THRESHOLD_LIMIT_MSITE = 5;

const RtoVehInfoListItems = ({
    title,
    list,
    isGradiant = false,
    openText = "",
    closedText = "",
    isDesktop = false
}) => {
    const { tokens } = useTokens();
    const listRef = useRef();
    const [isOpen, setIsOpen] = useState(false);
    const itemList = useMemo(() => getDlsCompatibleList(list), [list]);

    const onViewMoreHandler = async () => {
        setIsOpen(!isOpen);
        if (isOpen && listRef && listRef?.current) {
            listRef.current.scrollIntoView();
        }
    };

    return (
        <div className={"cvh"} styleName={`${isGradiant ? "styles.rtoVehInfoListItemsNotGradiant" : "styles.rtoVehInfoListItemsGradiant"}`}>
            {
                isDesktop ? <Heading level={NUMBER.TWO}>{title}</Heading> :
                    <Label level={NUMBER.ONE} fontWeight={"semibold"}>{title}</Label>
            }
            <div ref={listRef} styleName={`${isOpen ? "styles.listOpen" : "styles.listClose"}`}>
                <List
                    items={itemList}
                />
            </div>
            {
                itemList && itemList.length > LIST_THRESHOLD_LIMIT_MSITE &&
                <div
                    styleName={`styles.readMore`}
                    onClick={onViewMoreHandler}>
                    <Label
                        level={NUMBER.THREE}
                        fontWeight={"semibold"}
                        color={tokens.text_brand_text_brand}
                    >
                        {!isOpen ? openText : closedText}
                        <ArrowIcon />
                    </Label>
                </div>

            }
        </div>
    );
};

RtoVehInfoListItems.propTypes = {
    title: PropTypes.string,
    list: PropTypes.array,
    isGradiant: PropTypes.bool,
    openText: PropTypes.string,
    closedText: PropTypes.string,
    isDesktop: PropTypes.bool
};

export default RtoVehInfoListItems;
